import { defineSlotRecipe } from "@chakra-ui/react";

// Existing styling
export const modalRecipe = defineSlotRecipe({
  className: "chakra-dialog",
  slots: [
    "root",
    "backdrop",
    "header",
    "body",
    "footer",
    "closeTrigger",
    "content",
    "positioner",
  ],
  base: {
    root: {
      bg: "white",
      borderRadius: 12,
      mx: 4,
    },
    header: {
      textAlign: ["left", "center"],
      fontFamily: "heading",
      fontSize: 18,
      px: 8,
      pt: 8,
    },
    body: {
      px: 8,
      pt: 0,
      pb: 4,
      fontSize: 16,
    },
    footer: {
      px: 8,
      pb: 8,
    },
    backdrop: {
      bg: "rgba(45, 55, 72, 0.56)",
    },
    closeTrigger: {
      pos: "absolute",
      top: "2",
      insetEnd: "2",
    },
  },
  variants: {
    size: {
      xs: {},
      sm: {},
      md: {},
      lg: {},
      xl: {},
      "2xl": {},
      "3xl": {
        content: {
          maxW: "768px",
        },
      },
      "4xl": {
        content: {
          maxW: "1536px",
        },
      },
      xxl: {
        content: {
          maxW: "610px",
        },
      },
      full: {},
      cover: {},
    },
  },
});

// Bark version
export const modalSlotRecipe = defineSlotRecipe({
  className: "chakra-dialog",
  slots: [
    "root",
    "backdrop",
    "header",
    "body",
    "footer",
    "closeTrigger",
    "content",
    "positioner",
  ],
  base: {
    root: {
      bg: "base.200",
      borderRadius: 12,
      mx: 4,
    },
    header: {
      textAlign: ["left", "center"],
      textStyle: "heading.small",
      color: "text",
      padding: "20px 24px",
      fontWeight: 600,
    },
    body: {
      px: 8,
      pt: 0,
      pb: 4,
      fontSize: 16,
    },
    footer: {
      borderTop: "1px solid",
      borderColor: "lines",
    },
    backdrop: {
      bg: "rgba(45, 55, 72, 0.56)",
    },
    closeTrigger: {
      pos: "absolute",
      top: "2",
      insetEnd: "2",
      color: "base",
      _hover: {
        backgroundColor: "canvas",
      },
      _focusVisible: {
        outline: "none",
      },
    },
  },
  variants: {
    size: {
      xs: {},
      sm: {},
      md: {},
      lg: {
        content: {
          maxW: "788px",
        },
      },
      xl: {
        content: {
          maxW: "800px",
        },
      },
      // Existing sizes
      "2xl": {},
      "3xl": {
        content: {
          maxW: "768px",
        },
      },
      "4xl": {
        content: {
          maxW: "1536px",
        },
      },
      xxl: {
        content: {
          maxW: "610px",
        },
      },
      full: {},
      cover: {},
    },
  },
  defaultVariants: {
    size: "lg",
  },
});
